import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Grid, Typography, Box, TextField, Select, MenuItem,
  FormControl, Button, IconButton, InputAdornment, Tooltip, Divider, Dialog, CircularProgress,
  DialogTitle, DialogContent, DialogActions,
  Table, TableHead, TableBody, TableRow, TableCell, Paper, Link,
  Snackbar, Checkbox, ListItemText,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { Search, Clear, Cached, Close, Description as DescriptionIcon, KeyboardArrowDown } from '@material-ui/icons';
import QuickSummaryCards from './QuickSummaryCards';
import MfgMainTable from './MfgMainTable';
import {
  fetchMfgDashboard, fetchMfgQuickSummary,
  fetchMfgCMOList, fetchMfgPlants, fetchMfgBrands, fetchMfgProductTypes,
  fetchMfgCollabSavedFilters, saveMfgCollabFilters, clearMfgCollabFilters,
} from '../../../containers/actions/common/mfgCollabActions';
import { fetchSponsorsForCmo } from '../../../containers/actions/common/sponsorAPIAction';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
import StyledDialog from '../../../../common/models/Dialog';
//import AddIcon from '@material-ui/icons/Add';

const MENU_PROPS = {
  PaperProps: { style: { maxHeight: 300 } },
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  transformOrigin: { vertical: 'top', horizontal: 'left' },
  getContentAnchorEl: null,
};

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1, 2, 2, 1),
    overflowX: 'hidden',
    width: '100%',
    boxSizing: 'border-box',
    minHeight: 'calc(100vh - 100px)',
  },
  stylebutton: {
    borderRadius: '2rem',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    height: '32px',
    padding: '6px 16px',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
    },
    '&.Mui-disabled': {
      backgroundColor: '#ec6535',
      color: '#fff',
      opacity: 0.5,
    },
  },
  upload: {
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '2rem',
    minWidth: '180px',
    height: '36px',
    padding: '6px 20px',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
    },
  },
  blueButton: {
    backgroundImage: 'linear-gradient(to right, #301232, #1A2D6C, #173072)',
    color: 'white',
    border: '1px solid black',
    textTransform: 'none',
    borderRadius: '2rem',
    minWidth: '180px',
    height: '40px',
    padding: '8px 20px',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: 'green',
      background: 'green',
      color: 'white',
      border: '1px solid green',
    },
  },
  clearText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: '#173072',
      textDecoration: 'underline',
    },
  },
  searchSelect: {
    '& .MuiOutlinedInput-root': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
      outline: 'none !important',
      '& fieldset': {
        borderRight: '1px solid #000 !important',
        borderColor: '#000 !important',
        borderWidth: '1px !important',
      },
      '&:hover fieldset': {
        borderColor: '#000 !important',
        borderWidth: '1px !important',
      },
      '&.Mui-focused': {
        outline: 'none !important',
        '& fieldset': {
          borderColor: '#000 !important',
          borderWidth: '1px !important',
        },
      },
    },
  },
  searchInput: {
    '& .MuiOutlinedInput-root': {
      outline: 'none !important',
      '& fieldset': {
        borderLeft: 'none',
        borderColor: '#000 !important',
        borderWidth: '1px !important',
      },
      '&:hover fieldset': {
        borderLeft: 'none',
        borderColor: '#000 !important',
        borderWidth: '1px !important',
      },
      '&.Mui-focused': {
        outline: 'none !important',
        '& fieldset': {
          borderLeft: 'none',
          borderColor: '#000 !important',
          borderWidth: '1px !important',
        },
      },
    },
  },
  refreshSty: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  hgText: {
    fontWeight: 500,
    paddingRight: theme.spacing(1),
  },
  formPerPage: {
    minWidth: 60,
    fontSize: '0.875rem',
    '& .MuiOutlinedInput-root': {
      outline: 'none !important',
      '&.Mui-focused': {
        outline: 'none !important',
        '& fieldset': {
          borderWidth: '1px !important',
        },
      },
    },
  },
  outlined: {
    padding: theme.spacing(1),
  },
  formControl: {
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
      '&.Mui-focused': {
        backgroundColor: 'transparent !important',
      },
    },
  },
  padR20: {
    paddingRight: 20,
  },
  filterLabel: {
    fontWeight: 'bold',
    fontSize: '16px',
    marginBottom: '4px',
  },
});

class MfgCollabDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewOption: 'all',
      searchField: 'all',
      searchValue: '',
      vendorMosymphonyID: 'all',
      mfgPlant: 'all',
      brand: 'all',
      productType: 'all',
      pageSize: 10,
      pageNumber: 1,
      lastSynced: new Date(),
      initialVendorMosymphonyID: 'all',
      initialMfgPlant: 'all',
      initialBrand: 'all',
      initialProductType: 'all',
      savingFilters: false,
      saveDialogOpen: false,
      saveDialogSuccess: true,
      focusMode: false,
      tabPageSize: 100000, // Pagination disabled for Manufacturing tab tables — show ALL rows (sticky header + scroll). Per-page selector commented out.
      techTransferOpen: false,
      masterDocsOpen: false,
      uploadSuccess: false,
      uploadedFileName: '',
      selectedSponsorIds: [],
      sponsorOrganizations: [],
    };
  }

  getOrganizationIdFromToken() {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) return null;
      const decoded = jwtDecode(authToken);
      return decoded.organization_id || null;
    } catch {
      return null;
    }
  }

  componentDidMount() {
    // Skip API calls in static data mode
    const USE_STATIC_DATA_INIT = false; // flip to false when backend is ready
    if (USE_STATIC_DATA_INIT) return;

    // If Redux already has dashboard data (e.g. coming back from review page),
    // skip the full reload — UI shows existing data instantly
    const existingData = this.props.mfgCollab?.dashboard?.data;

    if (existingData && existingData.length > 0) {
      this.setState({ lastSynced: new Date() });
      return;
    }

    if (localStorage.getItem('collabType') !== 'cmo') {
      this.props.fetchMfgCMOList();
    }

    if (localStorage.getItem('collabType') === 'CMO') {
      const orgId = this.getOrganizationIdFromToken();
      if (orgId) {
        this.props.fetchSponsorsForCmo({ cmoOrgID: orgId });
      }
    }
    this.props.fetchMfgPlants();
    this.props.fetchMfgBrands();
    this.props.fetchMfgProductTypes();
    this.props.fetchMfgCollabSavedFilters().then((result) => {
      if (result?.status && result?.save_filter_options) {
        const opts = result.save_filter_options;
        this.setState({
          vendorMosymphonyID: opts.vendorMosymphonyID || 'all',
          mfgPlant: opts.mfgPlant || 'all',
          brand: opts.brand || 'all',
          productType: opts.productType || 'all',
          selectedSponsorIds: Array.isArray(opts.brandOwnerMosymphonyIds) ? opts.brandOwnerMosymphonyIds : [],
          initialVendorMosymphonyID: opts.vendorMosymphonyID || 'all',
          initialMfgPlant: opts.mfgPlant || 'all',
          initialBrand: opts.brand || 'all',
          initialProductType: opts.productType || 'all',
        }, () => {
          this.loadDashboard();
          this.loadQuickSummary();
        });
      } else {
        this.loadDashboard();
        this.loadQuickSummary();
      }
    });
  }

  componentDidUpdate(prevProps) {
    const sponsorData = this.props.sponsorsListForCmo;
    const prevSponsorData = prevProps.sponsorsListForCmo;
    if (sponsorData !== prevSponsorData && sponsorData?.status === true && sponsorData?.data?.length > 0) {
      this.setState({ sponsorOrganizations: sponsorData.data });
    }
  }

  loadDashboard = () => {
    const {
      viewOption, searchField, searchValue, vendorMosymphonyID,
      mfgPlant, brand, productType, pageSize, pageNumber, selectedSponsorIds,
    } = this.state;
    this.props.fetchMfgDashboard({
      // brandOwnerMosymphonyID: parseInt(localStorage.getItem('brandOwnerMosymphonyID')) || 0,
      vendorMosymphonyID,
      mfgPlant,
      brand,
      productType,
      brandOwnerMosymphonyIds: selectedSponsorIds,
      searchField: searchField === 'all' ? null : searchField,
      searchValue: searchValue || null,
      viewOption,
      pageSize,
      pageNumber,
      fetchedByUser: localStorage.getItem('email') || '',
    });
    this.setState({ lastSynced: new Date() });
  };

  loadQuickSummary = () => {
    this.props.fetchMfgQuickSummary({
      // brandOwnerMosymphonyID: parseInt(localStorage.getItem('brandOwnerMosymphonyID')) || 0,
      vendorMosymphonyID: this.state.vendorMosymphonyID,
      fetchedByUser: localStorage.getItem('email') || '',
    });
  };

  handleCardClick = (viewOption) => {
    if (viewOption === 'all') {
      // Clear filter — reload all from API
      this.setState({ viewOption: 'all', pageNumber: 1 }, this.loadDashboard);
    } else {
      // Frontend filter only — no API call
      this.setState({ viewOption, pageNumber: 1 });
    }
  };

  handlePageChange = (pageNumber) => {
    this.setState({ pageNumber }, this.loadDashboard);
  };

  handlePageSizeChange = (e) => {
    this.setState({ pageSize: e.target.value, pageNumber: 1 }, this.loadDashboard);
  };

  handleSearch = () => {
    this.setState({ pageNumber: 1 }, this.loadDashboard);
  };

  handleSaveFilters = async () => {
    const { vendorMosymphonyID, mfgPlant, brand, productType, selectedSponsorIds } = this.state;
    this.setState({ savingFilters: true });
    try {
      await this.props.saveMfgCollabFilters({ vendorMosymphonyID, mfgPlant, brand, productType, brandOwnerMosymphonyIds: selectedSponsorIds });
      this.setState({
        initialVendorMosymphonyID: vendorMosymphonyID,
        initialMfgPlant: mfgPlant,
        initialBrand: brand,
        initialProductType: productType,
        savingFilters: false,
        saveDialogOpen: true,
        saveDialogSuccess: true,
      }, () => {
        this.loadDashboard();
        this.loadQuickSummary();
      });
    } catch (err) {
      this.setState({
        savingFilters: false,
        saveDialogOpen: true,
        saveDialogSuccess: false,
      });
    }
  };

  handleClearAllFilters = async () => {
    this.setState({ savingFilters: true });
    await this.props.clearMfgCollabFilters();
    this.setState({
      viewOption: 'all',
      searchField: 'all',
      searchValue: '',
      vendorMosymphonyID: 'all',
      mfgPlant: 'all',
      brand: 'all',
      productType: 'all',
      pageNumber: 1,
      initialVendorMosymphonyID: 'all',
      initialMfgPlant: 'all',
      initialBrand: 'all',
      initialProductType: 'all',
      savingFilters: false,
      selectedSponsorIds: [],
    }, () => {
      this.loadDashboard();
      this.loadQuickSummary();
    });
  };

  handleRefresh = () => {
    this.loadDashboard();
    this.loadQuickSummary();
  };

  // Navigate to the Project Analytics screen. Append to the current
  // manufacturingcollaboration URL so the collabType/role/org/eco segments match
  // the active route regardless of casing.
  handleProjectAnalytics = () => {
    const base = (this.props.location && this.props.location.pathname) || '';
    this.props.history.push(`${base.replace(/\/+$/, '')}/project-analytics-view`);
  };

  filtersChanged = () => {
    const { vendorMosymphonyID, mfgPlant, brand, productType,
      initialVendorMosymphonyID, initialMfgPlant, initialBrand, initialProductType } = this.state;
    const changedFromInitial = vendorMosymphonyID !== initialVendorMosymphonyID
      || mfgPlant !== initialMfgPlant
      || JSON.stringify(brand) !== JSON.stringify(initialBrand)
      || productType !== initialProductType;
    const hasActiveFilter = vendorMosymphonyID !== 'all'
      || mfgPlant !== 'all'
      || (Array.isArray(brand) ? brand.length > 0 && JSON.stringify(brand) !== JSON.stringify(['all']) : brand !== 'all')
      || productType !== 'all';
    return changedFromInitial || hasActiveFilter;
  };

  render() {
    const { classes } = this.props;
    const mfgCollab = this.props.mfgCollab || {};
    const emptyList = { loading: false, data: [] };
    const {
      dashboard: reduxDashboard = { loading: false, data: [], totalCount: 0 },
      quickSummary = { loading: false },
      cmoList = emptyList,
      plantList = emptyList,
      brandList = emptyList,
      productTypeList = emptyList,
    } = mfgCollab;
    const { viewOption, savingFilters } = this.state;

    // Static dashboard data for local preview
    const USE_STATIC_DATA = false; // flip to false when backend is ready
    const STATIC_DASHBOARD = {
      loading: false,
      data: [
        { schrockenSLID: 1001, schrockenDeliveryScheduleBatchID: 400682, cmoMfg: 'Patheon - Cincinnati', productId: 'FG-001', productDescription: 'Repatha 140mg Syringe', poNumber: 'SA-2026-001', batchNumber: '400682', stage: 'NA', deliverableType: 'Manufacturing', poStatus: 'Confirmed', batchStatus: 'Manufacturing In Progress', completionDate: '2026-04-15', isDelayed: false, hasNewComments: true },
        { schrockenSLID: 1002, schrockenDeliveryScheduleBatchID: 400683, cmoMfg: 'Patheon - Cincinnati', productId: 'FG-002', productDescription: 'Aimovig 70mg Autoinjector', poNumber: 'SA-2026-002', batchNumber: '400683', stage: 'NA', deliverableType: 'Manufacturing', poStatus: 'Confirmed', batchStatus: 'QC Testing In Progress', completionDate: '2026-05-01', isDelayed: false, hasNewComments: false },
        { schrockenSLID: 1003, schrockenDeliveryScheduleBatchID: 400684, cmoMfg: 'Lonza - Basel', productId: 'FG-003', productDescription: 'Blincyto 35mcg IV', poNumber: 'SA-2026-003', batchNumber: '400684', stage: 'NA', deliverableType: 'Manufacturing', poStatus: 'Under Confirmation', batchStatus: 'Planned', completionDate: '2026-06-15', isDelayed: false, hasNewComments: false },
        { schrockenSLID: 1004, schrockenDeliveryScheduleBatchID: 400685, cmoMfg: 'Lonza - Basel', productId: 'FG-004', productDescription: 'Kyprolis 60mg Vial', poNumber: 'SA-2026-004', batchNumber: '400685', stage: 'NA', deliverableType: 'Manufacturing', poStatus: 'Confirmed', batchStatus: 'Pending CMO Release', completionDate: '2026-03-30', isDelayed: false, hasNewComments: true },
        { schrockenSLID: 1005, schrockenDeliveryScheduleBatchID: 400686, cmoMfg: 'Samsung Biologics - Incheon', productId: 'FG-005', productDescription: 'Prolia 60mg Syringe', poNumber: 'SA-2026-005', batchNumber: '400686', stage: 'NA', deliverableType: 'Manufacturing', poStatus: 'Confirmed', batchStatus: 'Shipped', completionDate: '2026-02-28', isDelayed: false, hasNewComments: false },
      ],
      totalCount: 5,
    };
    const dashboard = USE_STATIC_DATA ? STATIC_DASHBOARD : reduxDashboard;

    return (
      <div className={classes.root}>
        {/* ── Top Row: Filters + Action Buttons ── */}
        <Grid container style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap' }}>
          {/* Filter Section */}
          <Grid
            item
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'row',
              gap: '0.5rem',
              alignItems: 'flex-end',
            }}
          >

            {/* CMO — hidden when logged in as CMO */}
            {localStorage.getItem('collabType') !== "CMO" && (
            <Grid style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', flexDirection: 'column', marginTop: '10px' }}>
              <Grid>
                <Typography style={{ fontWeight: 'bold' }} className="dashboard-filter-labels">CMO:</Typography>
              </Grid>
              <Grid>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: '10rem', marginRight: '1rem' }}
                  className="dashboard-filter-dropdown"
                >
                  <Select
                    fullWidth
                    size="small"
                    variant="outlined"
                    displayEmpty
                    value={this.state.vendorMosymphonyID}
                    onChange={(e) => this.setState({ vendorMosymphonyID: e.target.value, mfgPlant: 'all' }, () => {
                      this.loadDashboard();
                      this.loadQuickSummary();
                    })}
                    MenuProps={MENU_PROPS}
                  >
                    <MenuItem value="all">All</MenuItem>
                    {(Array.isArray(cmoList.data) ? cmoList.data : []).map((cmo) => (
                      <MenuItem key={cmo.id} value={cmo.id}>{cmo.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            )}

                        {/* Sponsor — hidden when logged in as sponsor */}
            {localStorage.getItem('collabType') === "CMO" && (
            <Grid style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', flexDirection: 'column', marginTop: '10px' }}>
              <Grid>
                <Typography style={{ fontWeight: 'bold' }} className="dashboard-filter-labels">Sponsor:</Typography>
              </Grid>
              <Grid>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: '10rem', marginRight: '1rem' }}
                  className="dashboard-filter-dropdown"
                >
                  <Select
                    multiple
                    fullWidth
                    size="small"
                    variant="outlined"
                    displayEmpty
                    value={this.state.selectedSponsorIds}
                    renderValue={(selected) => {
                      if (selected.length === 0) return 'All';
                      if (selected.length === 1) {
                        return this.state.sponsorOrganizations.find(
                          (o) => String(o.organizationId) === String(selected[0])
                        )?.organizationName || String(selected[0]);
                      }
                      if (selected.length === this.state.sponsorOrganizations.length) return 'All';
                      return 'Multiple Selected';
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.includes('__all__')) {
                        const allSelected = this.state.selectedSponsorIds.length === this.state.sponsorOrganizations.length;
                        const next = allSelected ? [] : this.state.sponsorOrganizations.map((o) => o.organizationId);
                        this.setState({ selectedSponsorIds: next }, () => {
                          // this.loadDashboard();
                          // this.loadQuickSummary();
                        });
                      } else {
                        this.setState({ selectedSponsorIds: value }, () => {
                          // this.loadDashboard();
                          // this.loadQuickSummary();
                        });
                      }
                    }}
                    onClose={() => {
                    this.loadDashboard();
                    this.loadQuickSummary();
                  }}

                    MenuProps={MENU_PROPS}
                  >
                    <MenuItem value="__all__">
                      <Checkbox
                        checked={this.state.selectedSponsorIds.length === this.state.sponsorOrganizations.length && this.state.sponsorOrganizations.length > 0}
                        indeterminate={this.state.selectedSponsorIds.length > 0 && this.state.selectedSponsorIds.length < this.state.sponsorOrganizations.length}
                      />
                      <ListItemText primary="All" />
                    </MenuItem>
                    {this.state.sponsorOrganizations.map((option) => (
                      <MenuItem key={option.organizationId} value={option.organizationId}>
                        <Checkbox checked={this.state.selectedSponsorIds.some((id) => String(id) === String(option.organizationId))} />
                        <ListItemText primary={option.organizationName} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            )}

            {/* MFG Plant */}
            <Grid style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', flexDirection: 'column', marginTop: '10px' }}>
              <Grid>
                <Typography style={{ fontWeight: 'bold' }} className="dashboard-filter-labels">MFG Plant:</Typography>
              </Grid>
              <Grid>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: '10rem', marginRight: '1rem' }}
                  className="dashboard-filter-dropdown"
                >
                  <Select
                    fullWidth
                    size="small"
                    variant="outlined"
                    displayEmpty
                    value={this.state.mfgPlant}
                    onChange={(e) => this.setState({ mfgPlant: e.target.value }, () => {
                      this.loadDashboard();
                      this.loadQuickSummary();
                    })}
                    MenuProps={MENU_PROPS}
                  >
                    <MenuItem value="all">All</MenuItem>
                    {(Array.isArray(plantList.data) ? plantList.data : [])
                      .filter((plant) =>
                        this.state.vendorMosymphonyID === 'all' ||
                        String(plant.vendorMosymphonyID) === String(this.state.vendorMosymphonyID)
                      )
                      .map((plant) => (
                        <MenuItem key={plant.aslNumber} value={plant.aslNumber}>
                          {plant.mfgPlantShortName}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {/* Brand */}
            <Grid style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', flexDirection: 'column', marginTop: '10px' }}>
              <Grid>
                <Typography style={{ fontWeight: 'bold' }} className="dashboard-filter-labels">Brand:</Typography>
              </Grid>
              <Grid>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: '10rem', marginRight: '1rem' }}
                  className="dashboard-filter-dropdown"
                >
                  <Select
                    fullWidth
                    size="small"
                    variant="outlined"
                    displayEmpty
                    value={this.state.brand}
                    onChange={(e) => this.setState({ brand: e.target.value }, () => {
                      this.loadDashboard();
                      this.loadQuickSummary();
                    })}
                    MenuProps={MENU_PROPS}
                  >
                    <MenuItem value="all">All</MenuItem>
                    {(Array.isArray(brandList.data) ? brandList.data : []).map((b) => (
                      <MenuItem key={b.brand || b} value={b.brand || b}>{b.brand || b}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {/* Product Type */}
            <Grid style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', flexDirection: 'column', marginTop: '10px' }}>
              <Grid>
                <Typography style={{ fontWeight: 'bold' }} className="dashboard-filter-labels">Product Type:</Typography>
              </Grid>
              <Grid>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: '10rem', marginRight: '1rem' }}
                  className="dashboard-filter-dropdown"
                >
                  <Select
                    fullWidth
                    size="small"
                    variant="outlined"
                    displayEmpty
                    value={this.state.productType}
                    onChange={(e) => this.setState({ productType: e.target.value }, () => {
                      this.loadDashboard();
                      this.loadQuickSummary();
                    })}
                    MenuProps={MENU_PROPS}
                  >
                    <MenuItem value="all">All</MenuItem>
                    {(Array.isArray(productTypeList.data) ? productTypeList.data : [])
                      .filter((pt) => pt.activated === true)
                      .map((pt) => (
                        <MenuItem key={pt.productTypeID || pt.productTypeName || pt} value={pt.productTypeName || pt}>
                          {pt.productTypeName || pt}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {/* Save Filters */}
            <Grid style={{ display: 'flex', alignItems: 'flex-end' }}>
              <Button
                variant="contained"
                disableElevation
                disableRipple
                disableFocusRipple
                className={classes.stylebutton}
                onClick={this.handleSaveFilters}
                disabled={savingFilters}
                style={{ marginLeft: '4px', marginRight: '4px' }}
              >
                Save filters {savingFilters && <CircularProgress size={14} style={{ color: '#fff', marginLeft: 6 }} />}
              </Button>
            </Grid>

            {/* Clear All Filters */}
            <Grid style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '4px' }}>
              <Typography
                variant="caption"
                style={{
                  fontSize: '13px',
                  color: 'blue',
                  cursor: 'pointer',
                }}
                className={classes.clearText}
                onClick={this.handleClearAllFilters}
              >
                Clear all filters
              </Typography>
            </Grid>
          </Grid>

          {/* Project Analytics now lives in the focus-mode header (below) */}

        </Grid>

        {/* Horizontal line under filters when chevron opened */}
        {this.state.focusMode && <Divider style={{ margin: '0.5rem 0' }} />}

        {/* ── Quick Summary (when no row expanded) / Doc Buttons (when row expanded) ── */}
        {!this.state.focusMode ? (
          <QuickSummaryCards
            quickSummary={USE_STATIC_DATA ? {
              loading: false,
              plannedBatches: 3, batchesUnderManufacturing: 1, batchesUnderTesting: 2,
              batchesPendingCMORelease: 1, batchesPendingAmgenRelease: 0, batchesReadyForShipment: 1,
              batchesShipped: 1, batchesDelayedOnHoldOrCancelled: 0,
            } : quickSummary}
            activeCard={viewOption}
            onCardClick={this.handleCardClick}
          />
        ) : (
          <>
          <Grid
            container
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '0.75rem',
              padding: '0.5rem 0',
            }}
          >
            {/* Search (disabled) */}
            <Grid item style={{ display: 'flex', alignItems: 'center' }}>
              <Box style={{ display: 'flex', alignItems: 'stretch', height: 34, opacity: 0.55, pointerEvents: 'none' }}>
                <TextField
                  disabled
                  size="small"
                  variant="outlined"
                  placeholder="Search with textboxes for PO No. 1150345..."
                  style={{ minWidth: '320px' }}
                  InputProps={{
                    style: { height: 34, fontSize: '0.82rem', borderRadius: '4px 0 0 4px', backgroundColor: '#fff' },
                    endAdornment: (
                      <InputAdornment position="end">
                        <KeyboardArrowDown style={{ fontSize: 18, color: '#888' }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <IconButton
                  disabled
                  style={{
                    backgroundColor: '#EB5E28',
                    color: 'white',
                    borderRadius: '0 4px 4px 0',
                    padding: '5px',
                    marginLeft: '-1px',
                    height: 34,
                    width: 38,
                  }}
                >
                  <Search style={{ fontSize: '20px' }} />
                </IconButton>
              </Box>
            </Grid>
            {/* Per Page (for the expanded batch's tab tables) + View Active Batches (disabled) + Batch Analytics */}
            <Grid item style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginLeft: 'auto' }}>      
              <Button
                variant="outlined"
                disabled
                style={{
                  textTransform: 'none',
                  borderRadius: '2rem',
                  borderColor: '#333',
                  color: '#333',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  padding: '6px 22px',
                  whiteSpace: 'nowrap',
                }}
              >
                View Active Batches
              </Button>
              <Button
                variant="contained"
                disableElevation
                className={classes.blueButton}
                onClick={this.handleProjectAnalytics}
                style={{ whiteSpace: 'nowrap' }}
              >
                Batch Analytics
              </Button>
              {/* PER PAGE selector for Manufacturing tab tables — commented out per design.
                  Tables now show ALL rows with a sticky header inside a scrollable area. */}
              {/* <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Typography variant="body2" style={{ fontWeight: 700, whiteSpace: 'nowrap', fontSize: '0.75rem', letterSpacing: '0.03em', color: '#333' }}>
                  PER PAGE
                </Typography>
                <FormControl variant="outlined" size="small">
                  <Select
                    value={this.state.tabPageSize}
                    onChange={(e) => this.setState({ tabPageSize: e.target.value })}
                    style={{ backgroundColor: '#fff', height: 34 }}
                    MenuProps={MENU_PROPS}
                  >
                    {[5, 10, 15, 20, 25, 30].map((n) => (
                      <MenuItem key={n} value={n}>{n}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box> */}
            </Grid>
          </Grid>
          <Divider style={{ margin: '0.5rem 0' }} />
          </>
        )}

        {/* ── Search Section (hidden in focus mode) ── */}
        {!this.state.focusMode && <Grid
          container
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'end',
            flexWrap: 'wrap',
            marginTop: '0.75rem',
            overflow: 'visible',
          }}
        >
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              justifyContent: 'flex-start',
            }}
          >
            <Grid>
              <Typography
                variant="body2"
                style={{
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                  marginBottom: '0.75rem',
                  fontSize: '0.95rem',
                }}
              >
                Search by:
              </Typography>
            </Grid>
            <Grid
              item
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Box
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'stretch',
                  height: '36px',
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.searchSelect}
                  style={{ backgroundColor: '#F0F0F0', minWidth: '150px' }}
                >
                  <Select
                    value={this.state.searchField}
                    onChange={(e) => this.setState({ searchField: e.target.value, searchValue: '' })}
                    style={{ outline: 'none', height: '100%', fontSize: '0.9rem' }}
                    MenuProps={MENU_PROPS}
                  >
                    <MenuItem value="all">Select Criteria</MenuItem>
                    
                  {localStorage?.collabType === "CMO" && (
                    <MenuItem value="cmoSalesOrderNumber">SO Number</MenuItem>
                  )}  
                  <MenuItem value="scheduleAgreementNumber">PO Number</MenuItem>
                    <MenuItem value="productId">Product ID</MenuItem>
                    <MenuItem value="productDescription">Product Description</MenuItem>
                    <MenuItem value="vendorBatchNumber">Batch Number</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  size="small"
                  value={this.state.searchValue}
                  disabled={this.state.searchField === 'all'}
                  onChange={(e) => {
                    if (this.state.searchField !== 'all') {
                      this.setState({ searchValue: e.target.value });
                    }
                  }}
                  onKeyDown={(e) => e.key === 'Enter' && this.handleSearch()}
                  variant="outlined"
                  placeholder="Search"
                  className={classes.searchInput}
                  style={{ flex: 1, minWidth: 0 }}
                  InputProps={{
                    style: {
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                      paddingRight: this.state.searchValue ? '8px' : '0px',
                      height: '100%',
                    },
                    endAdornment: this.state.searchValue ? (
                      <InputAdornment position="end">
                        <Tooltip title="Clear search">
                          <IconButton
                            size="small"
                            onClick={() => {
                              this.setState({ searchValue: '', pageNumber: 1 }, this.loadDashboard);
                              // this.setState({ searchValue: '' })
                            }}
                            style={{ padding: '4px', marginRight: '4px' }}
                          >
                            <Clear fontSize="small" style={{ cursor: 'pointer', color: 'dimgray' }} />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ) : null,
                  }}
                />
                <IconButton
                  onClick={this.handleSearch}
                  disabled={this.state.searchField === 'all'}
                  style={{
                    backgroundColor: '#EB5E28',
                    color: 'white',
                    borderRadius: 0,
                    borderTopRightRadius: '4px',
                    borderBottomRightRadius: '4px',
                    border: '1px solid #000',
                    borderLeft: 'none',
                    padding: '8px 12px',
                    height: '100%',
                    minWidth: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Search style={{ fontSize: '20px' }} />
                </IconButton>
              </Box>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            sm={8}
            md={8}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'flex-start',
            }}
          >
            <Grid
              container
              justifyContent="flex-end"
              style={{ marginBottom: '2px' }}
            >
              <Typography variant="caption" className={classes.padR20}>
                {this.state.lastSynced
                  ? `Last synced @ ${moment(this.state.lastSynced).format('HH:mm:ss; DD MMMM, YYYY')}`
                  : ''}
              </Typography>
              <Typography
                variant="caption"
                color="primary"
                className={classes.refreshSty}
                onClick={this.handleRefresh}
              >
                Refresh
                <Cached color="primary" style={{ fontSize: 15 }} />
              </Typography>
            </Grid>
            <Grid container justifyContent="flex-end" alignItems="center">
              <Typography variant="body2" className={classes.hgText}>
                PER PAGE
              </Typography>
              <FormControl className={classes.formPerPage}>
                <Select
                  value={this.state.pageSize}
                  variant="outlined"
                  onChange={this.handlePageSizeChange}
                  style={{ outline: 'none' }}
                  classes={{ outlined: classes.outlined }}
                  MenuProps={MENU_PROPS}
                >
                  {[10, 25, 50].map((n) => (
                    <MenuItem key={n} value={n}>{n}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>}

        {/* ── Last Synced + PER PAGE (always visible, stacked top-bottom) ── */}
        {false && this.state.focusMode && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            style={{ marginTop: '0.75rem' }}
          >
            <Box display="flex" alignItems="center" style={{ gap: 12, marginBottom: 2 }}>
              <Typography variant="caption" className={classes.padR20}>
                {this.state.lastSynced
                  ? `Last synced @ ${moment(this.state.lastSynced).format('HH:mm:ss; DD MMMM, YYYY')}`
                  : ''}
              </Typography>
              <Typography
                variant="caption"
                color="primary"
                className={classes.refreshSty}
                onClick={this.handleRefresh}
              >
                Refresh
                <Cached color="primary" style={{ fontSize: 15 }} />
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" style={{ gap: 8 }}>
              <Typography variant="body2" className={classes.hgText}>
                PER PAGE
              </Typography>
              <FormControl className={classes.formPerPage}>
                <Select
                  value={this.state.pageSize}
                  variant="outlined"
                  onChange={this.handlePageSizeChange}
                  style={{ outline: 'none' }}
                  classes={{ outlined: classes.outlined }}
                  MenuProps={MENU_PROPS}
                >
                  {[10, 25, 50].map((n) => (
                    <MenuItem key={n} value={n}>{n}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        )}

        {/* Save Filters Dialog */}
        <Dialog open={this.state.saveDialogOpen} onClose={() => this.setState({ saveDialogOpen: false })} fullWidth maxWidth="sm">
          <StyledDialog
            title={this.state.saveDialogSuccess ? 'Saved successfully' : 'Failed to save filters'}
            subtitle={this.state.saveDialogSuccess ? 'Filters saved successfully!' : 'Failed to save filters.'}
            icon={!this.state.saveDialogSuccess}
            handleClose={() => this.setState({ saveDialogOpen: false })}
            noCloseButton={true}
          />
        </Dialog>

        {/* ── Main Data Table ── */}
        {(() => {
          const VIEW_FILTER_MAP = {
            plannedBatches: '__NONE__',
            underManufacturing: 'Manufacturing In Progress',
            underTesting: 'QC Testing In Progress',
            pendingCMORelease: 'Pending CMO Release',
            pendingAmgenRelease: 'Pending Sponsor Release',
            readyForShipment: 'Ready for Shipment',
            shipped: ['Shipped', 'Planned'],
            delayedHoldCancelled: ['Delayed', 'On Hold', 'Cancelled'],
          };
          const allData = dashboard.data || [];
          const filterVal = VIEW_FILTER_MAP[viewOption];
          const filteredData = (!filterVal || viewOption === 'all')
            ? allData
            : allData.filter(row => Array.isArray(filterVal)
                ? filterVal.includes(row.batchStatus)
                : row.batchStatus === filterVal);
          const seenPOs = new Set();
          const uniqueData = filteredData.filter(row => {
            const key = row.poNumber;
            if (!key || seenPOs.has(key)) return false;
            seenPOs.add(key);
            return true;
          });
          return (
        <MfgMainTable
          loading={dashboard.loading}
          data={uniqueData}
          totalCount={dashboard.totalCount}
          pageSize={this.state.pageSize}
          pageNumber={this.state.pageNumber}
          onPageChange={this.handlePageChange}
          onFocusModeChange={(isFocused) => this.setState({ focusMode: isFocused })}
          tabPageSize={this.state.tabPageSize}
        />
          );
        })()}

        {/* Tech Transfer Documents Popup */}
        <Dialog open={this.state.techTransferOpen} onClose={() => this.setState({ techTransferOpen: false })} maxWidth="md" fullWidth>
          <DialogTitle style={{ paddingBottom: '4px' }}>
            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a1a2e' }}>Tech Transfer Documents</Typography>
              <IconButton size="small" onClick={() => this.setState({ techTransferOpen: false })}><Close fontSize="small" /></IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <Table size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: '#F9F9FC' }}>
                  <TableCell style={{ fontWeight: 600 }}>Document Name</TableCell>
                  <TableCell style={{ fontWeight: 600, width: '120px' }}>Date</TableCell>
                  <TableCell style={{ fontWeight: 600 }}>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  { name: 'Process Transfer Protocol v2.1.pdf', date: '10-MAR-2026', desc: 'Complete process transfer protocol covering manufacturing procedures, critical process parameters, and acceptance criteria for production.' },
                  { name: 'Analytical Method Transfer Report.pdf', date: '08-MAR-2026', desc: 'Transfer of analytical methods including HPLC, dissolution, and assay methods from R&D to QC laboratory.' },
                  { name: 'Equipment Qualification Summary.pdf', date: '05-MAR-2026', desc: 'IQ/OQ/PQ summary for ANFD, reactor vessels, and filling line equipment qualified for commercial manufacturing.' },
                  { name: 'Cleaning Validation Protocol.pdf', date: '03-MAR-2026', desc: 'Cleaning validation protocol for shared equipment, including swab sampling plan and acceptance limits.' },
                ].map((doc, i) => (
                  <TableRow key={i} hover>
                    <TableCell>
                      <Box style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#1976d2', fontSize: '0.88rem' }}>
                        <DescriptionIcon style={{ fontSize: '1rem', color: '#1976d2' }} />
                        {doc.name}
                      </Box>
                    </TableCell>
                    <TableCell style={{ fontSize: '0.85rem', color: '#555' }}>{doc.date}</TableCell>
                    <TableCell style={{ fontSize: '0.83rem', color: '#444', lineHeight: 1.5 }}>{doc.desc}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ techTransferOpen: false })} style={{ textTransform: 'none', color: '#666' }}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Master Documents Popup */}
        <Dialog open={this.state.masterDocsOpen} onClose={() => this.setState({ masterDocsOpen: false })} maxWidth="md" fullWidth>
          <DialogTitle style={{ paddingBottom: '4px' }}>
            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a1a2e' }}>Master Documents</Typography>
              <IconButton size="small" onClick={() => this.setState({ masterDocsOpen: false })}><Close fontSize="small" /></IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <Table size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: '#F9F9FC' }}>
                  <TableCell style={{ fontWeight: 600 }}>Document Name</TableCell>
                  <TableCell style={{ fontWeight: 600, width: '120px' }}>Date</TableCell>
                  <TableCell style={{ fontWeight: 600 }}>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  { name: 'Master Batch Record - Paracetamol 50ml.pdf', date: '01-MAR-2026', desc: 'Master batch record for Paracetamol 50 ml vial, including bill of materials, manufacturing instructions, and in-process controls.' },
                  { name: 'Stability Protocol - FG-001.pdf', date: '28-FEB-2026', desc: 'Stability study protocol for accelerated and long-term storage conditions per ICH Q1A guidelines.' },
                  { name: 'Site Master File - Oxford Biomedica.pdf', date: '25-FEB-2026', desc: 'Comprehensive site master file covering facility layout, equipment list, quality system, and regulatory history.' },
                  { name: 'Raw Material Specifications.pdf', date: '20-FEB-2026', desc: 'Approved specifications for all raw materials and excipients used in manufacturing with CoA requirements.' },
                  { name: 'Packaging Specification - 50ml Vial.pdf', date: '18-FEB-2026', desc: 'Primary and secondary packaging specifications including label artwork, carton design, and shipping configuration.' },
                ].map((doc, i) => (
                  <TableRow key={i} hover>
                    <TableCell>
                      <Box style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#1976d2', fontSize: '0.88rem' }}>
                        <DescriptionIcon style={{ fontSize: '1rem', color: '#1976d2' }} />
                        {doc.name}
                      </Box>
                    </TableCell>
                    <TableCell style={{ fontSize: '0.85rem', color: '#555' }}>{doc.date}</TableCell>
                    <TableCell style={{ fontSize: '0.83rem', color: '#444', lineHeight: 1.5 }}>{doc.desc}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ masterDocsOpen: false })} style={{ textTransform: 'none', color: '#666' }}>Close</Button>
          </DialogActions>
        </Dialog>




        {/* Upload Success Snackbar */}
        <Snackbar
          open={this.state.uploadSuccess}
          autoHideDuration={4000}
          onClose={() => this.setState({ uploadSuccess: false })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <MuiAlert elevation={6} variant="filled" onClose={() => this.setState({ uploadSuccess: false })} severity="success">
            "{this.state.uploadedFileName}" uploaded successfully!
          </MuiAlert>
        </Snackbar>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mfgCollab: state.pcmp.common.mfgCollab,
  sponsorsListForCmo: state.pcmp.common.sponsor.sponsorsListForCmo,
});

export default withRouter(connect(mapStateToProps, {
  fetchMfgDashboard, fetchMfgQuickSummary,
  fetchMfgCMOList, fetchMfgPlants, fetchMfgBrands, fetchMfgProductTypes,
  fetchMfgCollabSavedFilters, saveMfgCollabFilters, clearMfgCollabFilters,
  fetchSponsorsForCmo,
})(
  withStyles(styles)(MfgCollabDashboard)
));
